import {request} from '../utils/request'

const livepaly = {
    // 获取试卷列表
    getIndexLiveRoom(data) {
        return request({
            method: "POST",
            url: "/api/live/liveService/getIndexLiveRoom",
            data
        });
    },
    getLiveRoomDetail(data){
        return request({
            method: "POST",
            url: "/api/live/liveService/getLiveRoomDetail",
            data
        });
    },
    updateLiveSubScript(data){
        return request({
            method: "POST",
            url: "/api/live/liveService/updateLiveSubScript",
            data
        });
    }
}

export default livepaly;